export const fade= {
	from: {
		opacity: 0,
			top: 20,
		position: 'relative'
	},
	to: {
		opacity: 1,
			top: 0,
		duration: 0.5,
	}
}
